module.exports = __webpack_public_path__ + "img/ISO9001.6ad03482.png";